import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  DevFlags = 'DevFlags',
}

export type DevFlagsMap = Record<DevFlag, boolean>;
export const DEV_FLAGS = new InjectionToken<DevFlagsMap>('DevFlagsMap');

export enum DevFlag {
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  EventDebug = 'debug_event_tracking',
  Hotjar = 'hotjar',
  NewTalentPools = 'new_talent_pools',
  PP24Enabled = 'pp24_enabled',
  ManageLocationsSearchFilters = 'manage_locations_search_filters_flag',
  TellentSas = 'tellent_sas',
  CandidateProfileRefresh = 'candidate_profile_refresh',
  LinkedInRSC = 'linkedin_rsc',
  Onboarding = 'onboarding',
  AnonymousCandidates = 'anonymous_candidates',
  AnonymousCandidatesBeta = 'anonymous_candidates_beta',
  ViewsCandidates = 'views_candidates',
  ViewsPinnedFilters = 'views_pinned_filters',
  ReportsExportImprovements = 'reports_export_improvements',
  NewJobEditor = 'new_job_editor',
  NewPromoteTab = 'new_promote_tab',
  ReportsExportImprovementsDebug = 'export_improvements_debug',
  ManualPlanMigration = 'manual_plan_change',
  EventRsvp = 'event_rsvp',
}
